import { Injectable, inject, signal } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  private readonly expiredState = signal(false);
  readonly expired = this.expiredState.asReadonly();

  markExpired() {
    this.expiredState.set(true);
  }

  clear() {
    this.expiredState.set(false);
  }
}

export const authExpiryInterceptor: HttpInterceptorFn = (request, next) => {
  const session = inject(AuthSessionService);
  const failedToken = (request.headers.get('Authorization') || '').replace(/^Bearer\s+/i, '');

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      const currentToken = localStorage.getItem('nzp_mobile_token') || '';
      if (failedToken && failedToken === currentToken && error.status === 401) {
        session.markExpired();
      }
      return throwError(() => error);
    })
  );
};
